import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type { JobTypesFilters, JobTypeSlice } from "./jobTypesTypes.ts";

const initialState: JobTypeSlice = {
  page: 1,
  rowsPerPage: 25,
  filter: {},
  sort: {
    key: "name",
    order: "asc",
  },
};

export const jobTypesSlice = createSlice({
  name: "jobTypes",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<JobTypeSlice["page"]>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (
      state,
      action: PayloadAction<JobTypeSlice["rowsPerPage"]>,
    ) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [filterType: keyof JobTypesFilters, filterValue: string | undefined]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (state, action: PayloadAction<JobTypeSlice["sort"]>) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  jobTypesSlice.actions;

export const selectPage = (state: RootState) => state.jobTypes.page;
export const selectRowsPerPage = (state: RootState) =>
  state.jobTypes.rowsPerPage;
export const selectFilter = (state: RootState) => state.jobTypes.filter;
export const selectSort = (state: RootState) => state.jobTypes.sort;

export default jobTypesSlice.reducer;
